import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Teccss.css'
import teclogo from '../Assets/Images/tec.png'
import {Link} from 'react-router-dom'
import { useLocation } from "react-router-dom";

function Kdptecsidebar({sidebar,openLogForm}) {

    

    let role;

     useEffect(()=>{

         role=localStorage.getItem('RoleId');

         if(role==='00'){

            document.getElementById("tec-Adduser").style.display="block"
            document.getElementById("tec-Assign").style.display="block"
         }
         else if (role==='01'){

            document.getElementById("tec-Adduser").style.display="block"
            document.getElementById("tec-Assign").style.display="block"
         }
         else{
            document.getElementById("tec-Adduser").style.display="none"
            document.getElementById("tec-Assign").style.display="none"

         }
           
        },[]);

      //assigning location variable
      const location = useLocation();

      //destructuring pathname from location
      const { pathname } = location;
  
      //Javascript split method to get the name of the path in array
      const splitLocation = pathname.split("/");
  
    return (
        <div  className ={sidebar ? "kdptec-sidebar kdptec-sidebar--open" : "kdptec-sidebar"}  id="kdptec-sidebar">
        <div className='kdptec-sidebar-title'>
            <div className='kdptec-sidebar-img'>
                <img src={teclogo } alt="logo"/>&nbsp; &nbsp;
                <Link to="/Kdp Tec"><span>KDP TEC </span></Link>
            </div>
  
        </div>
    
       <div className="kdptec-sidebar-menu">
    
        <div className={splitLocation[1] === "Tecadduser" ? "active-tec" :'kdptec-sidebar-link'} id="tec-Adduser">
        <i class="fa fa-user-o" id="TecSideIcon"></i>&nbsp; &nbsp;
            <Link to="/Tecadduser">Users</Link> 
        </div>
      
        <div className={splitLocation[1] === "TecProfile" ? "active-tec" :'kdptec-sidebar-link'}>
        <i class="fa fa-address-book-o" id="TecSideIcon"></i>&nbsp; &nbsp;
            <Link to="/TecProfile">Profile</Link> 
        </div>
       
        <div className=
        
        {splitLocation[1] === "Tecsection" ? "active-tec" :
        splitLocation[1] === "TecFirst" ? "active-tec" :
        splitLocation[1] === "TecLeaders" ? "active-tec" :
        splitLocation[1] === "TecProduct" ? "active-tec" :
        splitLocation[1] === "TecExpertise" ? "active-tec" :
        splitLocation[1] === "TecTechnology" ? "active-tec" :
        splitLocation[1] === "TecFooter" ? "active-tec" :
        splitLocation[1] === "TecAddress" ? "active-tec" :
        splitLocation[1] === "TecAbout" ? "active-tec" :
        splitLocation[1] === "TecLife" ? "active-tec" :
        splitLocation[1] === "TecGiving" ? "active-tec" :
        splitLocation[1] === "TecCareers" ? "active-tec" :
        splitLocation[1] === "TecMobile" ? "active-tec" :
        splitLocation[1] === "TecWeb" ? "active-tec" :
        splitLocation[1] === "TecCloud" ? "active-tec" :
        splitLocation[1] === "TecData" ? "active-tec" :
        splitLocation[1] === "TecBusiness" ? "active-tec" :
        splitLocation[1] === "TecDigital" ? "active-tec" :
        splitLocation[1] === "TecServices" ? "active-tec" :
        splitLocation[1] === "TecITES" ? "active-tec" :
        splitLocation[1] === "TecStaff" ? "active-tec" :
        splitLocation[1] === "TecQuality" ? "active-tec" :
        splitLocation[1] === "TecIndex" ? "active-tec" :
        splitLocation[1] === "TecCompany" ? "active-tec" :
        splitLocation[1] === "TecSExpertise" ? "active-tec" :
        splitLocation[1] === "TecSTechnology" ? "active-tec" :
        splitLocation[1] === "TecSProduct" ? "active-tec" :
        splitLocation[1] === "TecTalk" ? "active-tec" :
        'kdptec-sidebar-link'}>
        <i class="fa fa-list-alt" id="TecSideIcon"></i>&nbsp; &nbsp;
            <Link to="/Tecsection">Section</Link> 
        </div>
     
    
        <div className={splitLocation[1] === "Tecassign" ? "active-tec" :'kdptec-sidebar-link'} id="tec-Assign">
        <i class="fa fa-code-fork" id="TecSideIcon"></i>&nbsp; &nbsp;
            <Link to="/Tecassign">Assign</Link> 
        </div>
    
    
        <div className='kdptec-sidebar-link'>
        <i class="fa fa-sign-out fa-fade fa-xs" id="TecSideIcon"></i>&nbsp; &nbsp;
            <Link to=" "onClick={openLogForm}>Logout</Link> 
        </div>
       
        
       </div>


     
        </div>
    );
}

export default Kdptecsidebar;